// --- Our Modules --------------------------------------------------------------------------------
import "./styles.css";
// --- Logic --------------------------------------------------------------------------------------
type Props = { value: boolean; onChange: (value: boolean) => void; label: string; disabled?: boolean };

/**
 * On or off, as a switch rather than a tick.
 *
 * A checkbox is for "I have read this"; a switch is for a setting that takes effect — publishing a
 * project to the public catalog is the second kind. It is as tall as every other field so it can
 * share a row with one, and only as wide as its own words so it leaves the row's width to the field
 * beside it.
 */
export default function SwitchInput({ value, onChange, label, disabled }: Props) {
    return (
        <label className={`switch-input${value ? " switch-input--on" : ""}`}>
            <input type="checkbox" checked={value} onChange={(event) => onChange(event.target.checked)} disabled={disabled} />
            <span className="switch-input__track" aria-hidden="true">
                <span className="switch-input__thumb" />
            </span>
            <span className="switch-input__label">{label}</span>
        </label>
    );
}
